import type { FixtureNode, ComponentDefinition } from '../core/index.js';
import type { FixturePath } from '../core/FixturePath.js';

/**
 * Explorer's tree node structure, derived from FixtureNode.
 * This is the explorer's own representation of the fixture tree.
 */
export interface ExplorerTreeNode {
  readonly id: FixturePath;
  readonly name: string;
  readonly type: 'folder' | 'variants' | 'component';
  readonly children?: readonly ExplorerTreeNode[];
  readonly component?: ComponentDefinition;
  readonly labels: readonly string[];
}

/**
 * Converts a FixtureNode tree to ExplorerTreeNode tree.
 * This allows the explorer to have its own tree structure.
 */
export function toExplorerTree(node: FixtureNode): ExplorerTreeNode {
  return {
    id: node.id,
    name: node.name,
    type: node.type,
    children: node.children?.map(toExplorerTree),
    component: node.component,
    labels: node.labels,
  };
}
